<template>
	<div class='art-item art-item3 ahx0'>
		<common-top :commonTopData="commonTopData"></common-top>
        <div class="ahx">
			<comTable :config="tableConfig" :filterForm="filterForm" ref="table">
				<template v-slot:leftBten>
					<el-button v-if="checkLeve('252')" class="feature-item add" type="primary" size="small" icon="el-icon-plus" @click="showCom('addChannel')">添加渠道</el-button>
				</template>
			</comTable>
        </div>	
		<div v-show="ista" :style="shoXy" class="showNav">
			<span @click="el.clickFn()" v-for="(el,index) in showNav" :key="index">
				{{el.label}}
			</span>
		</div>
        <component @closeFn="close" v-model="componentData" v-bind:is="componentName"></component>
	</div>
</template>

<script>
import commonTop from '@/components/commonTop.vue'
import comTable from '@/components/firTable.vue'
import addChannel from './addChannel.vue'
export default {
	components: {
		commonTop,
		comTable,
        addChannel
	},
	data () {
		// 这里存放数据
		return {
			ista:false,
			shoXy:'',
			filterForm: [
				{prop: 'id', label: '渠道ID', pl: '请输入渠道ID检索'},
				{prop: 'channel_name', label: '渠道名称', pl: '请输入渠道名称'},
				{prop: 'channel', label: '渠道英文名', pl: '请输入渠道英文名'},
			],
            componentName:'',
            componentData:{},
            commonTopData: {
				"commonleftbtn": [],
			},
			tableConfig:{
				url:'quickerChannels',
				list:[
					{label:'ID',prop:'id'},
					{label:'渠道',prop:'channel'},
					{label:'渠道名称',prop:'channel_name'},
					{label:'创建时间',prop:'create_at'},
					{label:'操作',type:'tool',btns:[
						
						{label:'编辑',backLabel:()=>{
							return this.checkLeve('240')?'编辑':''
						},clickFn:da=>{
							if(!this.checkLeve('240')){
								return
							}
							this.showCom('addChannel',da)
						}},
						{label:'运营管理',clickFn:(da,ev)=>{
							if(da.channel=='tmwc_app'){
								this.ista = true;
								this.shoXy = `top:${ev.clientY}px;left:${ev.clientX}px`;
								return
							}
							if(da.channel=='qudu'){
								if(!this.checkLeve('74')){
									this.$message('没有权限请联系管理员')
									return
								}
								
								this.$router.push('/art/item6')
								return
							}

							this.$router.push({
								path:'item-pages',
								query:{
									channel:da.channel
								}
							})
						
						},blurFn:()=>{
							setTimeout(() => {
								this.ista = false
							}, 200);
							
						}},
					]},
					
				]
			},
			showNav:[
								{label:'用户信息表',clickFn:()=>{
									if(!this.checkLeve('68')){
										this.$message('没有权限请联系管理员')
										return
									}
									this.$router.push('/art/item0')
								}},
								{label:'展示-发现艺术',clickFn:()=>{
									if(!this.checkLeve('69')){
										this.$message('没有权限请联系管理员')
										return
									}
									this.$router.push('/art/item1?tabs=0')
								}},
								{label:'展示-玩趣古今',clickFn:()=>{
									if(!this.checkLeve('73')){
										this.$message('没有权限请联系管理员')
										return
									}
									this.$router.push('/art/item5')
								}},
								{label:'展示-空中逛展',clickFn:()=>{
									if(!this.checkLeve('70')){
										this.$message('没有权限请联系管理员')
										return
									}
									this.$router.push('/art/item2')
								}}
			],

			addLoading: false,
		}
	},
	created(){
		console.log(JSON.parse(localStorage.getItem("access")).menu_banner)
	
	},
	methods: {
        showCom(n,a){
			console.log(a)
            this.componentName = n;
            this.componentData = a || {}
		
        },
        close(n){
            this.showCom('')
            if(n=='sx'){
                this.$refs.table.getData();
            }
        },
	}
}
</script>
<style >
.ahx0{
	height: 100%;
}
.ahx{
	height: calc(100% - 60px);
}
.showNav{
	position: absolute;
	top: 0;
	left: 0;
}
.showNav>span {
    font-family: Microsoft YaHei;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: #1E1E1E;
    line-height: 29px;
    cursor: pointer;
}
.showNav>span:hover{
	color: #33B3FF;
}
.showNav {
    position: absolute;
    top: 0;
    left: 0;
    width: 133px;
	padding: 20px;
    background: #FFFFFF;
    border: 1px solid #D8D8D8;
    box-sizing: border-box;
    border-radius: 5px;

}
</style>